module.exports = __webpack_public_path__ + "static/HI-b97a0616c6813359ea463b65858bf470.svg";